import { render, staticRenderFns } from "./InfromacioRequerimientoForm.vue?vue&type=template&id=c2398afe&"
import script from "./InfromacioRequerimientoForm.vue?vue&type=script&lang=ts&"
export * from "./InfromacioRequerimientoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c2398afe', component.options)
    } else {
      api.reload('c2398afe', component.options)
    }
    module.hot.accept("./InfromacioRequerimientoForm.vue?vue&type=template&id=c2398afe&", function () {
      api.rerender('c2398afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerie/InfromacioRequerimientoForm.vue"
export default component.exports